import { supabase } from '@/lib/supabase';

export type ConnectionStatus =
  | 'none'
  | 'pending_sent'
  | 'pending_received'
  | 'accepted'
  | 'cooldown';

export type ConnectionWithProfile = {
  connection_id: string;
  other_id: string;
  full_name: string | null;
  avatar_url: string | null;
  verified: boolean;
  user_number: number | null;
  connected_at: string;
  current_level: number;
  portfolio_enabled: boolean;
  nickname: string | null;
};

export type PendingConnection = {
  connection_id: string;
  requester_id: string;
  full_name: string | null;
  avatar_url: string | null;
  verified: boolean;
  user_number: number | null;
  requested_at: string;
};

export async function getConnectionStatus(otherUserId: string): Promise<ConnectionStatus> {
  const { data, error } = await supabase.rpc('connection_status_with', { p_other_id: otherUserId });
  if (error) throw error;
  return (data as ConnectionStatus) ?? 'none';
}

export async function sendConnectionRequest(addresseeId: string): Promise<void> {
  const { error } = await supabase.rpc('send_connection_request', { p_addressee_id: addresseeId });
  if (error) throw error;
}

export async function respondConnectionRequest(requesterId: string, accept: boolean): Promise<void> {
  const { error } = await supabase.rpc('respond_connection_request', {
    p_requester_id: requesterId,
    p_accept: accept,
  });
  if (error) throw error;
}

export async function removeConnection(otherUserId: string): Promise<void> {
  const { error } = await supabase.rpc('remove_connection', { p_other_id: otherUserId });
  if (error) throw error;
}

export async function listMyConnections(): Promise<ConnectionWithProfile[]> {
  const { data, error } = await supabase.rpc('list_my_connections');
  if (error) throw error;
  return (data ?? []) as ConnectionWithProfile[];
}

export async function listPendingReceived(): Promise<PendingConnection[]> {
  const { data, error } = await supabase.rpc('list_pending_received');
  if (error) throw error;
  return (data ?? []) as PendingConnection[];
}

export type MutualPair = { user_a: string; user_b: string };

export async function getMutualConnections(): Promise<MutualPair[]> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, error } = await (supabase.rpc as any)('get_mutual_connections', { p_user_id: user.id });
  if (error) throw error;
  return ((data ?? []) as unknown) as MutualPair[];
}
